/**
 * FEAT-027 / BUG-028 — Piece Tone options, SPA side.
 *
 * Mirrors TONE_REGISTRY's keys in apps/api/src/pipeline/skills/tone-registry.ts
 * and publications.ts's TONES enum. Used by the Create Piece tone dropdown and
 * the Publication "Default tone" dropdown. Keep in lockstep with the API list —
 * a mismatch here is exactly what BUG-028 was.
 */

export interface ToneOption {
  value: string;
  label: string;
  desc: string;
}

export const TONES: ToneOption[] = [
  { value: "professional", label: "Professional", desc: "Clear, authoritative — consultant writing for peers" },
  { value: "conversational", label: "Conversational", desc: "Warm, approachable — like explaining to a smart colleague" },
  { value: "technical", label: "Technical", desc: "Precise, quantitative — practitioners who want specifics" },
  { value: "casual", label: "Casual", desc: "Relaxed, direct — author's natural speaking voice" },
  { value: "academic", label: "Academic", desc: "Formal, citation-heavy — scholarly audience" },
  { value: "persuasive", label: "Persuasive", desc: "Strong thesis — written to convince" },
];
